import React, {Component} from "react";
import {injectIntl} from "react-intl";

class Wait extends Component {

  render() {
    const {intl:{formatMessage}, selected, workspaceRequest} = this.props;
    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    return (
      <div className="col-sm-6 col-lg-3">
        <div className={["choice-card", selectedCss].join(' ')} onClick={this.props.onSelect}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">{formatMessage({id:'appointment.detail.mobility.wait.title'})}</h4>
          </header>
          <div className="choice-card__body">
            {workspaceRequest && <span>{formatMessage({id:'appointment.detail.mobility.wait.workspace'})}</span>}
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(Wait)
